import { createAsyncThunk } from "@reduxjs/toolkit";
import PinNumberService from "../../services/PinNumber/PinNumberService";

export const getVisitordetailsByCardNumber = createAsyncThunk(
  "visitDetailsbycardNumber",
  async (payload) => {
    const res = await PinNumberService.getVisitordetailsByCardNumber(payload);
    return res.data;
  },
);

export const forceUpdate = createAsyncThunk(
  "update/status",
  async (payload) => {
    const res = await PinNumberService.forceStatusUpdate(payload);
    return res.data;
  },
);

export const updateStatus = createAsyncThunk(
  "updateStatus",
  async (payload) => {
    const res = await PinNumberService.updateStatus(payload);
    return res.data;
  },
);

export const dymoPrinterForDashboard = createAsyncThunk(
  "updateStatus",
  async (payload) => {
    const res = await PinNumberService.dymoPrinterForDashboard(payload);
    return res.data;
  },
);
